import type { MouseEvent } from 'react';
import { faCopy, faTrashCan } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Icon } from '@/components/ui/icon';
import { IconTooltipButton } from '@/components/ui/icon-tooltip-button';
import { cn } from '@/lib/utils';

interface CardActionToolbarProps {
  totalCount: number;
  onDuplicate: () => void;
  onDelete: () => void;
  className?: string;
  vertical?: boolean;
}

export function CardActionToolbar({
  totalCount,
  onDuplicate,
  onDelete,
  className,
  vertical = false,
}: CardActionToolbarProps) {
  const handleDuplicate = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onDuplicate();
  };

  const handleDelete = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onDelete();
  };

  return (
    <div
      role="toolbar"
      aria-label="Card actions"
      className={cn(
        'flex gap-1 rounded-md border border-border/70 bg-background/95 p-1 shadow-sm backdrop-blur-sm',
        vertical ? 'flex-col items-center' : 'items-center',
        className,
      )}
      onPointerDown={(event) => {
        event.stopPropagation();
      }}
    >
      <IconTooltipButton
        tooltip="Duplicate card"
        size="icon"
        variant="ghost"
        colorScheme="secondary"
        className="size-7"
        onClick={handleDuplicate}
      >
        <Icon icon={faCopy} className="size-3.5" />
      </IconTooltipButton>
      <IconTooltipButton
        tooltip="Delete card"
        size="icon"
        variant="ghost"
        colorScheme="destructive"
        className="size-7"
        onClick={handleDelete}
        disabled={totalCount === 1}
      >
        <Icon icon={faTrashCan} className="size-3.5" />
      </IconTooltipButton>
    </div>
  );
}
